<template>
  <div>
    <transition name="slide-fade">
      <div v-if="show" :class="'alert-' + type" class="alert">
        <check-circle-icon v-if="type == 'success'" icon="check-circle" class="icon"/>
        <alert-circle-icon v-if="type == 'danger'" class="icon"/>
        <div class="alert-message" v-html="message"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { AlertCircleIcon, CheckCircleIcon } from "vue-feather-icons";
export default {
  name: "Alert",
  components: {
    AlertCircleIcon,
    CheckCircleIcon
  },
  data() {
    return {
      show: false,
      message: "",
      type: "success",
      timeout: null
    };
  },
  methods: {
    showAlert(options) {
      clearTimeout(this.timeout);
      this.type = options.type;
      this.message = options.message;
      this.show = true;
      this.timeout = setTimeout(() => {
        this.show = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/common/_variables.scss";

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateY(rem-calc(20));
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(rem-calc(-20));
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Alert.vue